@import '../../shared';

.form-feedback {
  border-radius: $border-radius-medium;
  font-size: $font-size-small;
  min-height: 3.2rem;
  margin-bottom: 1.5rem;
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  padding-left: .4rem;
  padding-right: .4rem;
  display: flex;
  align-items: center;
}

.form-feedback__icon {
  order: 1;
  max-width: 1.5rem;
  min-width: 1.5rem;
  margin-left: 0.4rem;
  margin-right: 1.2rem;
  height: 2.4rem;
  text-align: center;
}

.form-feedback__text {
  order: 2;
  margin-right: 0.8rem;
}

ul.form-feedback__text {
  width: 100%;
  list-style-position: inside;
  margin: 0;
  padding-left: 0;
}

.form-feedback--positive {
  background-color: $green-background;
  svg {
    fill: $green;
  }
}

.form-feedback--negative {
  background-color: $red-background;
  svg {
    fill: $red;
  }
}
